import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/web.immediate.js";
import $ from 'jquery';
import domready from 'domready';
import 'regenerator-runtime/runtime';
import './preselect';
import './productAccordions';
import './guestLogin';
domready(function () {
  //checks if the main PDP image has been loaded and removes the loading mask to prevent image positioning issues
  if ($('.catalog-product-view').find('.fotorama__stage__frame.fotorama__active')) {
    $('.gallery-placeholder .loading-mask').remove();
  }
});